import { WEB_COMPONENT_WEB_ACCESS_CONTROL_SCHEDULER_APP } from '../../webcomponents.constants';
import { WebAccessControlSchedulerComponent } from './component/WebAccessControlSchedulerComponent';

/**
 * The component for displaying the web access control schedules
 * @link https://bitdefender.atlassian.net/wiki/spaces/GZDOCS/pages/1459750929/DRAFT+-+Web+Access+Control+Schedules+Page
 */
export { WebAccessControlSchedulerComponent };
window.customElements.define(WEB_COMPONENT_WEB_ACCESS_CONTROL_SCHEDULER_APP, WebAccessControlSchedulerComponent);
